<template>
  <div id="enterprise-camera-list">
    <vs-alert
      color="warning"
      class="mt-5"
      icon-pack="feather"
      icon="icon-info"
      :active.sync="noCameras"
    >
      <span>登録されているカメラはありません</span>
    </vs-alert>

    <div class="relative" style="top: -48px; right: 0; max-height: 0">
      <div
        class="flex items-start justify-end flex-wrap"
        style="padding: 0.8rem 0.2rem"
      >
        <div class="flex items-center rounded" style="height: 30px">
          <div
            :class="{
              'grid-button-selected': gridLayout === 1,
              'grid-button-unselected': gridLayout !== 1,
            }"
            style="border: 2px solid #48a0f4; border-radius: 4px 0 0 4px"
          >
            <vs-tooltip class="test-test" text="カメラ一覧" position="bottom">
              <vs-dropdown class="cursor-pointer" vs-trigger-click>
                <div
                  id="grid-button-iconGrid1"
                  class="flex h-full justify-center items-center grid-button-icon"
                />

                <vs-dropdown-menu class="w-34 camera-list-layout-dropdown">
                  <vs-dropdown-item @click="setGridSize(1, 4)">
                    <div
                      class="camera-list-layout-dropdown-item flex items-center"
                    >
                      <span
                        class="flex items-center"
                        :style="{ color: AISEA_COLOR.BLACK }"
                      >
                        <img
                          :src="iconGridLayout14"
                          style="width: 24px; height: 24px"
                        />
                        <span class="whitespace-no-wrap ml-2">４列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setGridSize(1, 3)">
                    <div
                      class="camera-list-layout-dropdown-item flex items-center"
                    >
                      <span
                        class="flex items-center"
                        :style="{ color: AISEA_COLOR.BLACK }"
                      >
                        <img
                          :src="iconGridLayout13"
                          style="width: 24px; height: 24px"
                        />
                        <span class="whitespace-no-wrap ml-2">３列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setGridSize(1, 2)">
                    <div
                      class="camera-list-layout-dropdown-item flex items-center"
                    >
                      <span
                        class="flex items-center"
                        :style="{ color: AISEA_COLOR.BLACK }"
                      >
                        <img
                          :src="iconGridLayout12"
                          style="width: 24px; height: 24px"
                        />
                        <span class="whitespace-no-wrap ml-2">２列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-tooltip>
          </div>
          <div
            :class="{
              'grid-button-selected': gridLayout === 2,
              'grid-button-unselected': gridLayout !== 2,
            }"
            style="
              border-top: 2px solid #48a0f4;
              border-bottom: 2px solid #48a0f4;
            "
          >
            <vs-tooltip text="カメラ＋マップ" position="bottom">
              <vs-dropdown class="cursor-pointer" vs-trigger-click>
                <div
                  id="grid-button-iconGrid2"
                  class="flex h-full justify-center items-center grid-button-icon"
                />

                <vs-dropdown-menu class="w-34 camera-list-layout-dropdown">
                  <vs-dropdown-item @click="setGridSize(2, 3)">
                    <div
                      class="camera-list-layout-dropdown-item flex items-center"
                    >
                      <span
                        class="flex items-center"
                        :style="{ color: AISEA_COLOR.BLACK }"
                      >
                        <img
                          :src="iconGridLayout23"
                          style="width: 24px; height: 24px"
                        />
                        <span class="whitespace-no-wrap ml-2">３列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setGridSize(2, 2)">
                    <div
                      class="camera-list-layout-dropdown-item flex items-center"
                    >
                      <span
                        class="flex items-center"
                        :style="{ color: AISEA_COLOR.BLACK }"
                      >
                        <img
                          :src="iconGridLayout22"
                          style="width: 24px; height: 24px"
                        />
                        <span class="whitespace-no-wrap ml-2">２列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setGridSize(2, 1)">
                    <div
                      class="camera-list-layout-dropdown-item flex items-center"
                    >
                      <span
                        class="flex items-center"
                        :style="{ color: AISEA_COLOR.BLACK }"
                      >
                        <img
                          :src="iconGridLayout21"
                          style="width: 24px; height: 24px"
                        />
                        <span class="whitespace-no-wrap ml-2">１列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-tooltip>
          </div>
          <div
            :class="{
              'grid-button-selected': gridLayout === 3,
              'grid-button-unselected': gridLayout !== 3,
            }"
            style="border: 2px solid #48a0f4; border-radius: 0 4px 4px 0"
          >
            <vs-tooltip text="カメラ＋マップ＋ピックアップ" position="bottom">
              <vs-dropdown class="cursor-pointer" vs-trigger-click>
                <div
                  id="grid-button-iconGrid3"
                  class="flex h-full justify-center items-center grid-button-icon"
                />

                <vs-dropdown-menu class="w-34 camera-list-layout-dropdown">
                  <vs-dropdown-item @click="setGridSize(3, 3)">
                    <div
                      class="camera-list-layout-dropdown-item flex items-center"
                    >
                      <span
                        class="flex items-center"
                        :style="{ color: AISEA_COLOR.BLACK }"
                      >
                        <img
                          :src="iconGridLayout33"
                          style="width: 24px; height: 24px"
                        />
                        <span class="whitespace-no-wrap ml-2">３列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setGridSize(3, 2)">
                    <div
                      class="camera-list-layout-dropdown-item flex items-center"
                    >
                      <span
                        class="flex items-center"
                        :style="{ color: AISEA_COLOR.BLACK }"
                      >
                        <img
                          :src="iconGridLayout32"
                          style="width: 24px; height: 24px"
                        />
                        <span class="whitespace-no-wrap ml-2">２列</span>
                      </span>
                    </div>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-tooltip>
          </div>
        </div>

        <vs-tooltip text="表示設定" position="bottom">
          <div
            class="flex items-center justify-center filter-button cursor-pointer"
            @click="isFilterSidebarActive = !isFilterSidebarActive"
          >
            <span
              class="filter-icon material-icons"
              style="transform: rotate(90deg)"
              >tune</span
            >
          </div>
        </vs-tooltip>

        <vs-tooltip text="カメラリスト" position="bottom">
          <div
            class="flex items-center justify-center sort-button"
            @click="$router.push({ name: 'enterprise-management-camera-sort' })"
          >
            <span class="sort-icon material-icons">list</span>
          </div>
        </vs-tooltip>
      </div>
    </div>

    <div v-if="!noCameras">
      <div
        id="camera-content-container"
        class="relative clearfix flex items-start justify-between"
      >
        <div class="h-full" :style="gridLayoutStyle('leftBlock')">
          <!-- マップエリア -->
          <div
            id="map-on-camera-parent"
            class="relative w-full"
            :style="gridLayoutStyle('mapBlock')"
          >
            <div id="map-on-camera-list" class="w-full h-full" />
            <div
              class="flex justify-center items-center"
              style="
                flex-direction: column;
                position: absolute;
                bottom: 20px;
                right: 10px;
              "
            >
              <div
                class="flex justify-center items-center mt-1 rounded cursor-pointer"
                style="
                  width: 29px;
                  height: 29px;
                  background-color: white;
                  z-index: 9;
                "
                @click="initMapPosition"
              >
                <span class="material-icons" style="color: #333333"
                  >zoom_out_map</span
                >
              </div>
              <div
                class="flex justify-center items-center mt-1 rounded cursor-pointer"
                style="
                  width: 29px;
                  height: 29px;
                  background-color: white;
                  z-index: 9;
                "
                @click="resetMapPosition"
              >
                <span class="material-icons" style="color: #333333">home</span>
              </div>
            </div>

            <div
              class="flex justify-center items-center"
              style="
                flex-direction: column;
                position: absolute;
                bottom: 20px;
                left: 10px;
              "
            >
              <div
                class="flex justify-center items-center m-0 cursor-pointer"
                style="
                  width: 29px;
                  height: 29px;
                  background-color: white;
                  z-index: 9;
                  border-radius: 0.25rem 0.25rem 0 0;
                "
                @click="mapZoomIn"
              >
                <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#333"
                >
                  <path
                    d="M14.5 8.5c-.75 0-1.5.75-1.5 1.5v3h-3c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h3v3c0 .75.75 1.5 1.5 1.5S16 19.75 16 19v-3h3c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-3v-3c0-.75-.75-1.5-1.5-1.5z"
                  />
                </svg>
              </div>
              <div
                class="flex justify-center items-center m-0 cursor-pointer"
                style="
                  width: 29px;
                  height: 29px;
                  background-color: white;
                  z-index: 9;
                  border-top: 1px solid #dddddd;
                  border-bottom: 1px solid #dddddd;
                "
                @click="mapZoomOut"
              >
                <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#333"
                >
                  <path
                    d="M10 13c-.75 0-1.5.75-1.5 1.5S9.25 16 10 16h9c.75 0 1.5-.75 1.5-1.5S19.75 13 19 13h-9z"
                  />
                </svg>
              </div>
              <div
                class="flex justify-center items-center m-0 cursor-pointer"
                style="
                  width: 29px;
                  height: 29px;
                  background-color: white;
                  z-index: 9;
                  border-radius: 0 0 0.25rem 0.25rem;
                "
                @click="mapNorthUp"
              >
                <svg
                  :style="{ transform: `rotate(${mapRotateDeg}deg)` }"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#333"
                >
                  <path d="M10.5 14l4-8 4 8h-8z" />
                  <path id="south" d="M10.5 16l4 8 4-8h-8z" fill="#ccc" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <!-- カメラエリア -->
        <div :style="gridLayoutStyle('rightBlock')" style="margin-right: 12px">
          <!-- クローズアップカメラエリア -->
          <div
            id="close-up-camera-area"
            class="vs-con-loading__container"
            :style="gridLayoutStyle('closeUpCameraBlock')"
            style="position: relative"
          >
            <live-camera-grid-view
              v-if="closeUpCamera"
              ref="closeUpCameraGrid"
              :camera="closeUpCamera"
              :forcePlayFlg="closeUpCameraForcePlayFlg"
              :isCloseUpCamera="true"
              :gridHeight="'calc(( 50vh - 60px - 40px ))'"
              @onSelectCamera="onSelectCamera($event)"
            />
          </div>

          <!-- Liveカメラ(小) -->
          <div
            v-if="cameras.length !== 0"
            class="vs-row"
            :style="gridLayoutStyle('cameraListBlock')"
          >
            <div
              class="vs-col w-full relative"
              :style="{ width: gridWidth }"
              style="margin: 0 0 8px 8px"
              v-for="camera in dispCameras"
              v-show="camera.isShow"
              :key="camera.id"
              :id="camera.id"
            >
              <live-camera-grid-view
                :camera="camera"
                :gridLayout="gridLayout"
                :gridColNum="gridColNum"
                :gridHeight="gridHeight"
                @onSelectCamera="onSelectCamera($event)"
              />
              <div
                class="w-full h-full rounded"
                :style="{
                  border:
                    closeUpCamera &&
                    closeUpCamera.id === camera.id &&
                    gridLayout !== 1
                      ? '4px solid #48A0F4'
                      : null,
                }"
                style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  z-index: 99;
                  pointer-events: none;
                "
              />
            </div>
          </div>
        </div>
      </div>

      <!-- サイドメニューエリア -->
      <vs-sidebar
        class="items-no-padding background-absolute"
        position-right
        :click-not-close="clickNotClose"
        :hidden-background="clickNotClose"
        v-model="isFilterSidebarActive"
      >
        <div
          class="p-6 filter-container h-full filter-sidebar-background overflow-y-auto"
        >
          <div class="flex items-center justify-between">
            <div class="flex justify-start items-start">
              <h6 class="font-bold mb-3 filter-sidebar-font-color ml-1">
                表示設定
              </h6>
            </div>
            <feather-icon
              icon="XIcon"
              svgClasses="h-7 w-7"
              class="filter-sidebar-font-color"
              @click="isFilterSidebarActive = !isFilterSidebarActive"
            />
          </div>
          <vs-divider class="filter-sidebar-divide-color" />

          <div v-if="vesselsName && vesselsName.length > 0">
            <vs-collapse>
              <vs-collapse-item>
                <div
                  slot="header"
                  class="aisea-text-16-400-white mb-4"
                  id="filter-sidebar-vessel-header"
                >
                  船舶
                </div>
                <div
                  class="filter-sidebar-font-color filter-sidebar-list-by-category"
                >
                  <vs-row vs-type="flex" class="mt-1 my-3">
                    <vs-col
                      vs-order="1"
                      vs-type="flex"
                      vs-justify="start"
                      vs-align="center"
                      vs-w="10"
                    >
                      <span>すべて</span>
                    </vs-col>
                    <vs-col
                      vs-order="2"
                      vs-type="flex"
                      vs-justify="flex-end"
                      vs-align="center"
                      vs-w="2"
                    >
                      <vs-switch color="#48a0f4" v-model="switchVesselAll" />
                    </vs-col>
                  </vs-row>

                  <vs-divider
                    class="filter-sidebar-divide-color"
                    style="opacity: 0.4"
                  />
                  <ul>
                    <li
                      v-for="vessel in vesselsName"
                      :key="vessel.id"
                      class="mb-3 flex items-center justify-between"
                    >
                      <vs-checkbox
                        v-model="filter.vesselIds"
                        :vs-value="vessel.id"
                        :disabled="vesselIdsCheckboxDisabled"
                        class="ml-0"
                        color="#48a0f4"
                        >{{ vesselName(vessel) }}</vs-checkbox
                      >
                    </li>
                  </ul>
                </div>
              </vs-collapse-item>
            </vs-collapse>

            <vs-divider class="filter-sidebar-divide-color" />
          </div>

          <vs-collapse>
            <vs-collapse-item>
              <div
                slot="header"
                class="aisea-text-16-400-white mb-4"
                id="filter-sidebar-other-header"
              >
                その他
              </div>
              <div
                class="filter-sidebar-font-color filter-sidebar-list-by-category"
              >
                <vs-row vs-type="flex" class="mt-1 my-3">
                  <vs-col
                    vs-order="1"
                    vs-type="flex"
                    vs-justify="start"
                    vs-align="center"
                    vs-w="10"
                  >
                    <span>すべて</span>
                  </vs-col>
                  <vs-col
                    vs-order="2"
                    vs-type="flex"
                    vs-justify="flex-end"
                    vs-align="center"
                    vs-w="2"
                  >
                    <vs-switch color="#48a0f4" v-model="switchOtherAll" />
                  </vs-col>
                </vs-row>
              </div>
            </vs-collapse-item>
          </vs-collapse>

          <div class="mt-8">
            <vs-button
              class="filter-action-button"
              color="#48a0f4"
              @click="onResetFilter"
              >リセット</vs-button
            >
            <vs-button
              class="filter-action-button"
              color="#48a0f4"
              @click="updateFilterCondition"
              :disabled="
                filter.category < 0 ||
                (filter.category === 1 && filter.vesselIds.length === 0)
              "
              >決定</vs-button
            >
          </div>
        </div>
      </vs-sidebar>
    </div>

    <fixed-point-cameras-layer
      ref="fixedPointCamerasLayer"
      :map="map"
      :mapEvent="mapEvent"
    />
    <vessel-map-layer ref="vesselMapLayer" :map="map" :mapEvent="mapEvent" />
  </div>
</template>

<script>
import Vue from "vue";
import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";
import Mapbox from "mapbox-gl";
import _ from "lodash";
import { CAMERA_CATEGORY } from "@/config/const";
import { MapSource } from "@/config/Map.js";
import VesselMapLayer from "../../../live-map/layers/VesselMapLayer";
import FixedPointCamerasLayer from "../../../live-map/layers/FixedPointCamerasLayer";
import { ColorMixin, DeviceInfoMixin } from "@/mixins";
import { createNamespacedHelpers, mapGetters } from "vuex";
const { mapState: mapStateOfCameraList, mapActions: mapActionsOfCameraList } =
  createNamespacedHelpers("enterpriseCameraList");
const { mapActions: mapActionsOfLiveMap } = createNamespacedHelpers("liveMap");
// 船舶描画のために必要なもの
import WebWorkerForFetchVesselGeometry from "worker-loader!@/utils/worker/WebWorkerForFetchVesselGeometry.js";
import WebWorkerForFetchVesselGeometryForSignal from "worker-loader!@/utils/worker/WebWorkerForFetchVesselGeometryForSignal.js";
import moment from "moment-timezone";
import TileBelt from "@mapbox/tilebelt";
import { MAP_DEFAULT_POSITION } from "@/config/const";
import AuthService from "@/services/authService";

// TODO: 現状では使用していないようなのでコメントアウト
// // mixins
// import {
//   StoreMonitoringVesselManeuveringMixin,
// } from "@/mixins/addon/secure-dataflow";

export default {
  components: {
    VesselMapLayer,
    FixedPointCamerasLayer,
    LiveCameraGridView: () => import("./components/CameraGridView.vue"),
  },
  mixins: [
    // StoreMonitoringVesselManeuveringMixin,
    ColorMixin,
    DeviceInfoMixin,
  ],
  data() {
    return {
      filter: {
        category: 0,
        vesselIds: [],
        sortOrderName: "ASC",
      },
      sortOrderName: "ASC",
      allVesselIds: [],
      vesselIdsCheckboxDisabled: false,
      categories: [
        { id: CAMERA_CATEGORY.ALL, label: "すべて", isSelected: true },
        { id: CAMERA_CATEGORY.VESSEL, label: "船舶", isSelected: false },
        { id: CAMERA_CATEGORY.OTHERS, label: "その他", isSelected: false },
      ],
      isFilterSidebarActive: false,
      isFilterSidebarInitialized: false,
      clickNotClose: true,
      gridLayout: 3,
      gridColNum: 2,
      gridWidth: "",
      gridHeight: "",
      map: null,
      pos: null,
      mapRotateDeg: 0,
      closeUpCamera: null,

      switchVesselAll: true,
      switchOtherAll: true,

      origFilter: {
        category: 0,
        vesselIds: [],
        sortOrderName: "",
      },
      origSwitchVesselAll: true,
      origSwitchOtherAll: true,

      iconGridPathMap: {
        iconGrid1: require("@/assets/images/icons/cameras/grid_1.svg"),
        iconGrid2: require("@/assets/images/icons/cameras/grid_2.svg"),
        iconGrid3: require("@/assets/images/icons/cameras/grid_3.svg"),
      },

      iconGridLayout14: require("@/assets/images/icons/cameras/grid_layout_1_4.svg"),
      iconGridLayout13: require("@/assets/images/icons/cameras/grid_layout_1_3.svg"),
      iconGridLayout12: require("@/assets/images/icons/cameras/grid_layout_1_2.svg"),
      iconGridLayout23: require("@/assets/images/icons/cameras/grid_layout_2_3.svg"),
      iconGridLayout22: require("@/assets/images/icons/cameras/grid_layout_2_2.svg"),
      iconGridLayout21: require("@/assets/images/icons/cameras/grid_layout_2_1.svg"),
      iconGridLayout33: require("@/assets/images/icons/cameras/grid_layout_3_3.svg"),
      iconGridLayout32: require("@/assets/images/icons/cameras/grid_layout_3_2.svg"),
      vesselColors: ["pink", "skyblue", "yellow", "palegreen"],
      isStyleReady: false,
      mapEvent: null,
      pulsing: null,
      fixedPointCameraMap: {},
      fixedPointCamerasSourceId: "fixedPointCamerasSource",
      fixedPointCamerasLayerId: "fixedPointCamerasLayer",
      fixedPointCamerasTextLayerId: "fixedPointCamerasTextLayer",
      fixedPointCamerasPulsingImageId: "fixedPointCamerasPulsingImageId",
      fixedPointCamerasPulsingLayerId: "fixedPointCamerasPulsingLayerId",
      layersMinZoomOfFixedPointCameras: 4,
      vesselCamerasPulsingImageId: "vesselCamerasPulsingImageId",
      closeUpCameraForcePlayFlg: false,
      prevRoute: null,

      intervalIdList: [],
      // 船舶取得のために必要なもの
      webWorker: null,
      // Map life cycle
      intervalHistoryList: [],
      intervalIdForGetFeatureCollection: [],
      intervalIdForGetFeatureCollectionLong: [],
      timeoutIdForGetFeatureCollection: [],
      // キャッシュ
      cache: {
        quadKey: null, // 同じQuadKeyエリアは表示しない用
        searchQuadKeys: [], // 検索QuadKey一覧
      },
      featurePositionMap: new Map(),
      featureVectorMap: new Map(),
      featurePolygonMap: new Map(),
    };
  },
  computed: {
    ...mapStateOfCameraList({
      noCameras: (state) => state.noCameras,
      vessels: (state) => state.vessels,
      vesselsName: (state) => state.vesselsName,
      cameras: (state) => state.cameras,
    }),
    ...mapGetters({
      mapCenter: "enterpriseMapSetting/getCenter",
      getAddonFlag: "getAddonFlag",
    }),
    dispCameras() {
      let dispCameras = this.cameras.map((camera) => {
        let dispCamera = JSON.parse(JSON.stringify(camera));
        const vesselColorIndex =
          this.allVesselIds.findIndex((x) => x === dispCamera.vesselId) %
          this.vesselColors.length;
        const vesselColor =
          this.vesselColors[
            vesselColorIndex >= 0
              ? vesselColorIndex
              : this.vesselColors.length - 1
          ];
        const vessel = this.vesselsName.find(
          (x) => x.id === dispCamera.vesselId,
        );
        dispCamera.vesselColor = vesselColor;

        const isFixedPointCamera = Object.keys(
          this.fixedPointCameraMap,
        ).includes(dispCamera.id);
        dispCamera.vesselCapitalLetter = isFixedPointCamera
          ? "FIXED"
          : vessel
          ? vessel.name.charAt(0)
          : " ";

        return dispCamera;
      });

      return dispCameras;
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
  },
  watch: {
    gridLayout() {
      this.$nextTick(() => {
        this.map.jumpTo({
          center: this.pos.center,
        });
        this.map.resize();

        if (this.gridLayout === 3) {
          FireStoreService.getAccountSetting("camera_list").then(
            (cameraListSettings) => {
              if (cameraListSettings) {
                this.setCloseUpCamera(cameraListSettings["close_up_camera_id"]);
              }
            },
          );
        } else {
          this.setCloseUpCamera(null);
          this.mirroringVideo(false);
        }
      });
      FireStoreService.setAccountSetting("camera_list", {
        grid_layout: this.gridLayout,
      });
    },
    gridColNum() {
      FireStoreService.setAccountSetting("camera_list", {
        grid_col_num: this.gridColNum,
      });
    },
    isFilterSidebarActive() {
      if (this.isFilterSidebarActive) {
        this.backupFilterValue();
        if (!this.isFilterSidebarInitialized) {
          setTimeout(() => {
            this.onClickCollapse();
          }, 500);
          this.isFilterSidebarInitialized = true;
        }
      }
    },
    switchVesselAll() {
      // フィルタで全ての船舶所属カメラを選択
      this.categories.forEach((category) => {
        category.isSelected = false;
      });
      this.vesselIdsCheckboxDisabled = !this.switchVesselAll;
      if (this.switchVesselAll) {
        if (this.switchOtherAll) {
          this.categories.find((x) => x.id === CAMERA_CATEGORY.ALL)
            .isSelected === true;
          this.filter.category = CAMERA_CATEGORY.ALL;
        } else {
          this.categories.find((x) => x.id === CAMERA_CATEGORY.VESSEL)
            .isSelected === true;
          this.filter.category = CAMERA_CATEGORY.VESSEL;
        }
      } else {
        if (this.switchOtherAll) {
          this.categories.find((x) => x.id === CAMERA_CATEGORY.OTHERS)
            .isSelected === true;
          this.filter.category = CAMERA_CATEGORY.OTHERS;
        } else {
          this.filter.category = -1;
        }
      }
    },
    switchOtherAll() {
      // フィルタで全てのその他カメラを選択
      this.categories.forEach((category) => {
        category.isSelected = false;
      });
      if (this.switchOtherAll) {
        if (this.switchVesselAll) {
          this.categories.find((x) => x.id === CAMERA_CATEGORY.ALL)
            .isSelected === true;
          this.filter.category = CAMERA_CATEGORY.ALL;
        } else {
          this.categories.find((x) => x.id === CAMERA_CATEGORY.OTHERS)
            .isSelected === true;
          this.filter.category = CAMERA_CATEGORY.OTHERS;
        }
      } else {
        if (this.switchVesselAll) {
          this.categories.find((x) => x.id === CAMERA_CATEGORY.VESSEL)
            .isSelected === true;
          this.filter.category = CAMERA_CATEGORY.VESSEL;
        } else {
          this.filter.category = -1;
        }
      }
    },
    onChangeWindowSize() {
      this.mirroringVideo();
    },
    verticalNavMenuWidth() {
      setTimeout(() => {
        this.mirroringVideo();
      }, 1200);
    },
  },
  methods: {
    ...mapActionsOfCameraList([
      "fetchCameras",
      "filterCamera",
      "resetCameraListState",
    ]),
    ...mapActionsOfLiveMap(["fetchFixedPointCameras", "getLastPosition"]),

    gridLayoutStyle(blockName) {
      // レイヤー分割の指定

      const leftBlockWidth = "35%";
      const gridAreaHeight = "100vh - 60px";
      const closeUpCameraHeight = "( 50vh - 60px - 32px )";

      if (blockName === "leftBlock") {
        return {
          display: this.gridLayout !== 1 ? "block" : "none",
          width: this.gridLayout !== 1 ? leftBlockWidth : "0",
          padding: "0",
        };
      } else if (blockName === "rightBlock") {
        return {
          width:
            this.gridLayout !== 1 ? `calc(100% - ${leftBlockWidth})` : "100%",
        };
      } else if (blockName === "mapBlock") {
        return {
          height: `calc( ${gridAreaHeight} )`,
        };
      } else if (blockName === "closeUpCameraBlock") {
        return {
          display: this.gridLayout === 3 ? "block" : "none",
          height: `calc( ${closeUpCameraHeight} - 8px )`,
        };
      } else if (blockName === "cameraListBlock") {
        return {
          height:
            this.gridLayout === 3
              ? `calc( ${gridAreaHeight} - ${closeUpCameraHeight} )`
              : `calc( ${gridAreaHeight} )`,
          margin: 0,
          "overflow-y": "auto",
        };
      }
      return {};
    },

    async loadMapbox() {
      this.pos = await LocalDbService.getDefaultPosition();
      const mapStyleLocal = await LocalDbService.getMapStyle();
      Mapbox.accessToken = process.env.VUE_APP_MAPBOX_TOKEN;
      Mapbox.prewarm();
      Mapbox.maxParallelImageRequests = 10;
      this.map = new Mapbox.Map({
        container: "map-on-camera-list",
        style: mapStyleLocal,
        center: this.pos.center,
        zoom: 4,
        doubleClickZoom: false,
        maxZoom: 18,
        attributionControl: false,
        localIdeographFontFamily: "'Noto Sans', sans-serif",
      });
      this.map.on("rotate", () => {
        this.mapRotateDeg = this.map.getBearing() * -1;
      });

      this.map.on("style.load", async () => {
        await this.setupMapSources();
        this.updateMap(this);

        this.$nextTick(async () => {
          this.createPulsingAnimation(this.map);
          this.addPulsingAnimationLayer();

          this.$refs.vesselMapLayer.initialized = true;
          this.$refs.vesselMapLayer.isMapReady();

          // 固定カメラの初期化
          this.$refs.fixedPointCamerasLayer.createPulsing(this.map);
          await this.$refs.fixedPointCamerasLayer.setMapSource();
          this.setMapLayerOfFixedPointCameras();
          this.isStyleReady = true;
        });
      });
      const self = this;
      this.map.on("dblclick", () => {
        self.initMapPosition();
      });
      this.map.on("movestart", self.mapMoveStart);
      this.map.on("moveend", self.mapMoveEnd);
      this.map.on("zoomstart", self.mapZoomStart);
      this.map.on("zoomend", self.mapZoomEnd);
    },
    mapMoveStart() {
      this.mapEvent = "mapMoveStart";
    },
    mapMoveEnd() {
      this.updateMap(this);
    },
    mapZoomStart() {
      this.mapEvent = "mapZoomStart";
    },
    mapZoomEnd() {
      this.mapEvent = "mapZoomEnd";
      this.updateMap(this);
    },
    updateMap: _.debounce((self) => {
      if (self.map) {
        // FireStore監視
        self.setFeatureCollectionsFromApiWithInterval();
      }
    }, 1500),

    /**
     * 船舶位置情報群をタイミングをずらしながらAPI取得する.
     *
     * 以下の順番で非同期取得を開始.
     *
     * 1. map表示の中心座標を含む１辺20kmのタイルとその周辺＝合計９枚のタイルを取得開始.
     *      ---> 画面表示領域の真ん中あたりを先行して表示
     *
     * 2. 日本全域をカバーするタイルを取得開始. ( 暫定で Zoom:6 x 25枚のタイル に分割して並列取得)
     *      ---> 画面をZoom-outした時のために、あらかじめ周辺海域を含めた日本全域取得しておく
     *
     * 3. 画面に表示されている範囲をタイル分割して取得. 以降ポーリングで定期的に更新 (短周期).
     *      ---> 画面表示領域を常に更新 （Zoom値と画面解像度によるが、おおよそ 3x6 〜 5x7 枚のタイルを並列更新）
     *      ---> ユーザが Zoom変更(mapbox.zoomEnd) あるいは位置変更(mapbox.moveEnd)したら、画面表示領域の左上座標と右下座標を再計算＋ポーリング再実行
     *
     * 4. 日本全域をカバーする25枚のタイルをポーリングで定期的に更新 (長周期).
     *      ---> 日本全域の船舶位置が古くならない程度に最低限の更新
     *
     */
    setFeatureCollectionsFromApiWithInterval() {
      const japanAreaStartDelaySecond = 3; // 日本全体の取得の遅延開始時期(秒) おおむね表示範囲のFeatureCollectionを取得し終わった頃にスタート
      const japanAreaPollingSecond = 600; // 日本全体のポーリング間隔(秒)
      const nearAreaTileDelaySecond = 0.2; // 各タイルを並列取得する時の多重度を抑えるための時間差指定（画面表示領域）
      const japanAreaTileDelaySecond = 0.3; // 各タイルを並列取得する時の多重度を抑えるための時間差指定（日本全体）
      const cleanerPollingSecond = 60; // 指定時間以上経過している船舶は非表示にする処理のポーリング間隔(秒)

      const mapZoom = this.map.getZoom();
      const nearAreaPollingSecond = // 画面表示領域のポーリング間隔(秒)
        mapZoom >= 14
          ? 3 // zoom = 14 => scaleUnit = 200m ポリゴン表示開始サイズ
          : mapZoom >= 10
          ? 10 // zoom = 10 => scaleUnit = 3km 通常（初期表示サイズ）
          : mapZoom >= 9
          ? 3 * 60 // zoom =  9 => scaleUnit = 5km 船舶は○アイコン（東京湾全域程度）
          : mapZoom >= 5
          ? 10 * 60 // zoom =  5 => scaleUnit = 100km ほぼ日本全域
          : 10 * 60;

      if (this.intervalIdForGetFeatureCollection.length > 0) {
        // 短周期のインターバルがあればリセット（画面位置やZoom値が変わっているため）
        this.clearShortPolling([...this.intervalIdForGetFeatureCollection]);
        this.intervalIdForGetFeatureCollection.splice(0);
      }

      let tileZoom = 0;
      let tileDistanceFromCenter = 0;
      let tileList = [];

      // 初回： mapboxに表示された中心座標とそのzoom値に応じた9枚のパネルを取得. // １辺が約20km zoom=11 x 9枚で東京湾周辺が埋まる
      tileZoom = Math.floor(this.map.getZoom() > 11 ? 11 : this.map.getZoom()); // zoom-out を考慮して、ある程度zoomしたら、それより狭い範囲を取得しない
      tileDistanceFromCenter = 1;
      tileList = this.getTileListSquare(
        tileZoom,
        tileDistanceFromCenter,
        this.mapCenter,
      );
      this.setFeatureCollectionsFromApi(tileList, 0, null, "init-near");

      // ブラウザ枠に含まれるタイルをポーリング
      const intervalId = setInterval(() => {
        if (!this.checkPollingValidation("poll-near")) {
          return;
        }

        const currentZoom = Math.floor(this.map.getZoom());
        tileZoom = currentZoom > 10 ? 10 : currentZoom < 8 ? 8 : currentZoom;
        tileList = this.getTileListRectangle(
          tileZoom,
          this.map.getBounds().getNorthWest(),
          this.map.getBounds().getSouthEast(),
        );
        this.setFeatureCollectionsFromApi(
          tileList,
          nearAreaTileDelaySecond,
          null,
          "poll-near",
        );
      }, nearAreaPollingSecond * 1000);
      this.intervalIdForGetFeatureCollection.push({
        intervalId: intervalId,
        momentValue: moment().valueOf(),
      });

      if (!this.isReadyGetFeatureCollectionLong) {
        this.isReadyGetFeatureCollectionLong = true;

        // 日本全域を取得開始 （広域取得はページ初回表示時にポーリング開始したらページ消滅まで継続）
        setTimeout(() => {
          // 日本全域 : 初回
          tileZoom = 6;
          tileDistanceFromCenter = 2;
          const japanCenterLngLat = {
            lng: MAP_DEFAULT_POSITION.center[0],
            lat: MAP_DEFAULT_POSITION.center[1],
          };
          tileList = this.getTileListSquare(
            tileZoom,
            tileDistanceFromCenter,
            japanCenterLngLat,
          );
          this.setFeatureCollectionsFromApi(
            tileList,
            japanAreaTileDelaySecond,
            tileZoom,
            "init-japan",
          );

          // 日本全域 : ポーリング
          this.intervalIdForGetFeatureCollectionLong.push(
            setInterval(() => {
              if (!this.checkPollingValidation("poll-japan")) {
                return;
              }

              tileZoom = 8;
              tileDistanceFromCenter = 12;
              this.setFeatureCollectionsFromApi(
                tileList,
                japanAreaTileDelaySecond,
                tileZoom,
                "poll-japan",
              );
            }, japanAreaPollingSecond * 1000),
          );
        }, japanAreaStartDelaySecond * 1000);

        // 指定時間以上経過している船舶は非表示とするため、定期的にクリーナーを実行。
        this.intervalIdForGetFeatureCollectionLong.push(
          setInterval(() => {
            if (!this.checkPollingValidation("cleaner")) {
              return;
            }

            const ownVesselIds = this.allVesselIds; // カメラ管理ではカメラ船を自社船として表示
            const tenMinutesAgo = moment().subtract(10, "minutes").valueOf();
            Array.from(this.featurePositionMap).forEach(
              ([vesselId, featureObj]) => {
                // 自社船(カメラ船)： 無期限で表示
                // 自社船以外の船：10分以上経過している場合は表示しない。
                if (
                  ownVesselIds.includes(vesselId) ||
                  (!ownVesselIds.includes(vesselId) &&
                    featureObj.properties.t < tenMinutesAgo)
                ) {
                  this.featurePositionMap.delete(vesselId);
                  this.featureVectorMap.delete(vesselId);
                  this.featurePolygonMap.delete(vesselId);
                }
              },
            );

            // メモリリーク対策。  頻繁に更新されるfeature***Mapのオブジェクトポインタを差し替えて、ガベージコレクションを促す。
            const featurePositionMapBackup = _.cloneDeep(
              this.featurePositionMap,
            );
            const featureVectorMapBackup = _.cloneDeep(this.featureVectorMap);
            const featurePolygonMapBackup = _.cloneDeep(this.featurePolygonMap);
            this.featurePositionMap = null;
            this.featureVectorMap = null;
            this.featurePolygonMap = null;
            this.featurePositionMap = featurePositionMapBackup;
            this.featureVectorMap = featureVectorMapBackup;
            this.featurePolygonMap = featurePolygonMapBackup;

            // vessel_geometryAPI取得に使っている setTimeout のタイマーIDも、古すぎるものはクリーニング。
            this.timeoutIdForGetFeatureCollection =
              this.timeoutIdForGetFeatureCollection.filter(
                (timeout) => timeout.t > tenMinutesAgo,
              );
          }, cleanerPollingSecond * 1000),
        );
      }

      // 参考数値：
      // zoom=11 x 9枚で東京湾周辺が埋まる（zoom=11 の場合、 日本緯度では１辺が約20km）
      // zoom=6 x 25枚で日本が埋まる。 全世界は zoom=6 x 64 x 64 でカバー ( 2^6 = 64 )
    },

    checkPollingValidation(keyName) {
      if (this.$route.name !== "enterprise-management-camera-list") {
        // beforeDestroy() で削除しきれなかったポーリング処理を検知したら、終了処理をコール。
        Vue.$log.debug(
          `remained polling process has detected. So, destroy. (${keyName}) this.$route.name = `,
          this.$route.name,
        );
        this.destroyPolling();
        return false;
      }
      return true;
    },
    clearShortPolling(intervalList) {
      this.intervalHistoryList.push(intervalList);
      this.intervalHistoryList.forEach((intervalSet) => {
        intervalSet.forEach((intervalObj) =>
          clearInterval(intervalObj.intervalId),
        );
      });
    },
    destroyPolling() {
      this.webWorker.terminate();
      this.clearShortPolling([...this.intervalIdForGetFeatureCollection]);
      this.intervalIdForGetFeatureCollection = [];
      this.intervalIdForGetFeatureCollectionLong.forEach((interval) =>
        clearInterval(interval),
      );
      this.intervalIdForGetFeatureCollectionLong = [];
      this.timeoutIdForGetFeatureCollection.forEach((timeout) =>
        clearTimeout(timeout.timeoutId),
      );
      this.timeoutIdForGetFeatureCollection = [];
    },

    /**
     * 表示されたmapの左上緯度経度から右下緯度経度に含まれるタイル番号を算出する.
     */
    getTileListRectangle(tileZoom, northWestLngLat, southEastLngLat) {
      let northWestTile = TileBelt.pointToTile(
        northWestLngLat.lng,
        northWestLngLat.lat,
        tileZoom,
      );
      let souchEastTile = TileBelt.pointToTile(
        southEastLngLat.lng,
        southEastLngLat.lat,
        tileZoom,
      );

      const leftTileNumber = northWestTile[0] - 1;
      const rightTileNumber = souchEastTile[0] + 1;
      const topTileNumber = northWestTile[1] - 1;
      const bottomTileNumber = souchEastTile[1] + 1;

      return this.getTileList(
        tileZoom,
        topTileNumber,
        rightTileNumber,
        bottomTileNumber,
        leftTileNumber,
      );
    },

    /**
     * 表示されたmapの中心緯度経度とその周辺のタイル番号を算出する.
     */
    getTileListSquare(tileZoom, tileDistanceFromCenter, centerLngLat) {
      // tileDistanceFromCenter(normal):  0=1x1=1枚, 1=3x3=9枚, 2=5x5=25枚,

      // 地図の中央を含むタイル
      let centerTile = TileBelt.pointToTile(
        centerLngLat.lng,
        centerLngLat.lat,
        tileZoom,
      );

      const leftTileNumber = centerTile[0] - tileDistanceFromCenter;
      const rightTileNumber = centerTile[0] + tileDistanceFromCenter;
      const topTileNumber = centerTile[1] - tileDistanceFromCenter;
      const bottomTileNumber = centerTile[1] + tileDistanceFromCenter;

      const tileList = this.getTileList(
        tileZoom,
        topTileNumber,
        rightTileNumber,
        bottomTileNumber,
        leftTileNumber,
      );

      // 中心から渦巻き状に展開するように並べ替え
      const stepDirectionList = [
        [0, 1], // 下移動
        [-1, 0], // 左移動
        [0, -1], // 上移動
        [1, 0], // 右移動
      ];
      const centerX = Math.floor((leftTileNumber + rightTileNumber) / 2);
      const centerY = Math.floor((topTileNumber + bottomTileNumber) / 2);

      let tileListWork = Array.from(tileList);
      let stepIndex = 0;
      let tileListSpiral = [];
      let i = 0;

      let workX = centerX;
      let workY = centerY;
      let findIndex = tileListWork.findIndex(
        (tile) => tile[0] === workX && tile[1] === workY,
      );
      tileListSpiral.push(tileListWork[findIndex]);
      tileListWork.splice(findIndex, 1);

      while (tileListWork.length > 0 || i < 200) {
        let findIndex = tileListWork.findIndex(
          (tile) =>
            tile[0] === workX + stepDirectionList[stepIndex][0] &&
            tile[1] === workY + stepDirectionList[stepIndex][1],
        );
        if (findIndex >= 0) {
          tileListSpiral.push(tileListWork[findIndex]);
          tileListWork.splice(findIndex, 1);

          workX = workX + stepDirectionList[stepIndex][0];
          workY = workY + stepDirectionList[stepIndex][1];
          stepIndex = (stepIndex + 1) % stepDirectionList.length;
        } else {
          stepIndex =
            (stepIndex + stepDirectionList.length - 1) %
            stepDirectionList.length;
        }

        i = i + 1;
      }
      return tileListSpiral;
    },

    /**
     *  引数の指定範囲に従ったタイルリストを取得.
     */
    getTileList(
      tileZoom,
      topTileNumber,
      rightTileNumber,
      bottomTileNumber,
      leftTileNumber,
    ) {
      let tileList = [];
      for (let ry = topTileNumber; ry <= bottomTileNumber; ry++) {
        for (let rx = leftTileNumber; rx <= rightTileNumber; rx++) {
          tileList.push([rx, ry, tileZoom]);
        }
      }
      return tileList;
    },

    /**
     * 引数のタイルリスト毎にAPIをコールし、取得結果を既存のFeatureCollectionにマージして 該当のMapSourceにセット.
     *
     */
    setFeatureCollectionsFromApi(tileList, delaySecond, zoom, purpose) {
      Vue.$log.debug(
        moment().format("HH:mm:ss"),
        `setFeatureCollectionsFromApi() purpose = ${purpose}. tileList.length = ${tileList.length}`,
      );
      // zoomが3未満の場合はAPIを発行しない
      // NOTE: LiveMapでは閾値が4だが、カメラ用のマップではデフォルト4のため
      //       少し余裕を持たせている
      if (this.map.getZoom() < 3) {
        return;
      }
      // tile[2]（tileのzoom値）が0のときにquadkeyが空文字になるため除外する
      const newTileList = tileList.filter((tile) => tile[2] > 0);

      newTileList.forEach((tile, index) => {
        const timeoutId = setTimeout(() => {
          try {
            const originalQuadKey = TileBelt.tileToQuadkey(tile); // そのタイルのquadKey番号
            const nextQuadKey = (parseInt(originalQuadKey, 4) + 1)
              .toString(4) // そのタイルの次のquadKey番号 (4進数計算)
              .padStart(originalQuadKey.length, "0"); // 0パディング

            let northWestQuadKey = originalQuadKey;
            let southEastQuadKey = nextQuadKey;

            const payload = {
              north_west_quad_key: northWestQuadKey,
              south_east_quad_key: southEastQuadKey,
              own_vessel_display_duration_minutes: 0, // カメラ船を無期限で表示
              enterprise_vessel_ids: this.allVesselIds.join(","),
              zoom: Math.floor(zoom || this.map.getZoom()),
            };

            AuthService.getIdToken().then((idToken) => {
              // webWorkerで vessel_geometry取得APIをコール
              this.webWorker.postMessage({
                payload: payload,
                idToken: idToken,
              });
            });
          } catch (e) {
            Vue.$log.debug("setFeatureCollection failed. ", e);
          }
        }, delaySecond * index * 1000); // 引数のtileListの順番で処理できるように少しだけ時間をずらして取得.

        this.timeoutIdForGetFeatureCollection.push({
          timeoutId: timeoutId,
          t: moment().valueOf(),
        });
      });
    },

    async setVesselGeometryToMapSources(receivedData) {
      const featureMapBySource = receivedData.featureMapBySource;
      if (featureMapBySource && featureMapBySource.positions) {
        // featurePositionMapは LiveMap.vueのローカル変数。 e[0] は vessel_id. 頻繁な更新なのでmutationによる値保存は実施しない。
        Object.entries(featureMapBySource.positions).forEach(
          ([vesselId, featureObj]) => {
            this.featurePositionMap.set(vesselId, featureObj);
          },
        );
        Object.entries(featureMapBySource.vectors).forEach(
          ([vesselId, featureObj]) => {
            this.featureVectorMap.set(vesselId, featureObj);
          },
        );
        Object.entries(featureMapBySource.polygons).forEach(
          ([vesselId, featureObj]) => {
            this.featurePolygonMap.set(vesselId, featureObj);
          },
        );

        // mapboxへ setData
        this.setDataToMap(
          this.map,
          this.featurePositionMap,
          this.featureVectorMap,
          this.featurePolygonMap,
          this.allVesselIds,
        );
      }
    },

    // TODO: 現時点では選択船・自社船は他社船として表示
    //   カメラ管理ではcameraに紐づいた船舶を自社船として表示しているため
    setDataToMap: _.throttle(
      (
        map,
        featurePositionMap,
        featureVectorMap,
        featurePolygonMap,
        cameraVesselIds,
      ) => {
        const ownVesselIds = cameraVesselIds; // カメラ船を自社船として表示
        const positionFeatureList = Array.from(featurePositionMap.values());
        const vectorFeatureList = Array.from(featureVectorMap.values());
        const polygonFeatureList = Array.from(featurePolygonMap.values());

        // 他社船 position
        let otherVesselPointFeatureCollection = {
          type: "FeatureCollection",
          features: positionFeatureList
            .filter((x) => x != null)
            .filter((x) => !ownVesselIds.includes(x.properties.id)),
        };
        map
          .getSource(MapSource.VesselPointSource.id)
          .setData(otherVesselPointFeatureCollection);

        // 自社船 position
        let ownVesselPointFeatureCollection = {
          type: "FeatureCollection",
          features: positionFeatureList
            .filter((x) => x != null)
            .filter((x) => ownVesselIds.includes(x.properties.id)),
        };
        map
          .getSource(MapSource.OwnVesselPointSource.id)
          .setData(ownVesselPointFeatureCollection);
        map
          .getSource(MapSource.OwnVesselMarkerSource.id)
          .setData(ownVesselPointFeatureCollection);

        // ベクトル表示
        let vesselFeatures = vectorFeatureList.map((x) => {
          return {
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates: [
                [
                  x.geometry.coordinates[0].coordinates[0],
                  x.geometry.coordinates[0].coordinates[1],
                ],
                [
                  x.geometry.coordinates[1].coordinates[0],
                  x.geometry.coordinates[1].coordinates[1],
                ],
              ],
            },
            properties: x.properties,
          };
        });
        let vesselVectorFeatureCollection = {
          type: "FeatureCollection",
          features: vesselFeatures,
        };
        map
          .getSource(MapSource.VesselVectorSource.id)
          .setData(vesselVectorFeatureCollection);

        // ポリゴン表示
        const polygonFeaturesWork = polygonFeatureList.flat();
        const polygonFeatures = polygonFeaturesWork.map((x) => {
          return {
            type: "Feature",
            geometry: {
              type: "Polygon",
              coordinates: [
                x.geometry.coordinates[0].map((x1) => x1.coordinates),
              ],
            },
            properties: x.properties,
          };
        });

        // ポリゴン (他社船)
        let otherVesselPolygonFeatureCollection = {
          type: "FeatureCollection",
          features: polygonFeatures,
        };
        map
          .getSource(MapSource.VesselPolygonSource.id)
          .setData(otherVesselPolygonFeatureCollection);

        // ポリゴン表示(自社船)
        // NOTE: カメラ船を自社船として表示
        let ownVesselPolygonFeatureCollection = {
          type: "FeatureCollection",
          features: polygonFeatures.filter((x) =>
            ownVesselIds.includes(x.properties.id),
          ),
        };
        map
          .getSource(MapSource.OwnVesselPolygonSource.id)
          .setData(ownVesselPolygonFeatureCollection);
      },
      800,
    ),
    createPulsingAnimation(map) {
      // パルスアニメーションオブジェクト生成
      let size = 150; // 円の大きさ
      let self = this;
      this.pulsing = {
        width: size,
        height: size,
        data: new Uint8Array(size * size * 4),
        onAdd: function () {
          let canvas = document.createElement("canvas");
          canvas.width = this.width;
          canvas.height = this.height;
          this.context = canvas.getContext("2d");
        },

        render: function () {
          const duration = 4000; // パルス１周期の時間(ms)
          const outerInnerRate = 0.3; // パルスの開始円周と終了円周との比率
          const increaseSpeedRate = 0.5; // パルスの拡大スピード
          let t = (performance.now() % duration) / duration;

          let innerRadius = (size / 2) * outerInnerRate;
          let outerRadius =
            innerRadius +
            (size / 2) * (1 - outerInnerRate) * t * increaseSpeedRate;
          let context = this.context;

          context.clearRect(0, 0, this.width, this.height);
          context.beginPath();
          context.arc(
            this.width / 2,
            this.height / 2,
            outerRadius,
            0,
            Math.PI * 2,
          );
          context.fillStyle = "rgba(255, 255, 255," + (1 - t) + ")";
          context.fill();

          this.data = context.getImageData(0, 0, this.width, this.height).data;

          self.mapTriggerRepaint(map);

          return true;
        },
      };
    },
    mapTriggerRepaint: _.debounce((map) => {
      // map.triggerRepaint() は負荷が大きいので、ある程度まとめてから処理実行。
      map.triggerRepaint();
    }, 200),

    addPulsingAnimationLayer() {
      // パルスアニメーション表示
      this.map.addImage(this.vesselCamerasPulsingImageId, this.pulsing, {
        pixelRatio: 2,
      });

      this.map.addLayer({
        id: MapSource.OwnVesselPointSource.id,
        type: "symbol",
        source: MapSource.OwnVesselPointSource.id,
        maxzoom: 20,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-image": this.vesselCamerasPulsingImageId,
        },
      });
    },

    mapZoomIn() {
      this.map.zoomTo(this.map.getZoom() + 1);
    },
    mapZoomOut() {
      this.map.zoomTo(this.map.getZoom() - 1);
    },
    mapNorthUp() {
      this.map.flyTo({ bearing: 0 });
      this.mapRotateDeg = 0;
    },

    setMapLayerOfFixedPointCameras() {
      // 固定カメラのレイヤー

      this.map.addImage(this.fixedPointCamerasPulsingImageId, this.pulsing, {
        pixelRatio: 2,
      });
      this.map.addLayer({
        id: this.fixedPointCamerasPulsingLayerId,
        type: "symbol",
        minzoom: this.layersMinZoomOfFixedPointCameras,
        source: this.fixedPointCamerasSourceId,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-image": this.fixedPointCamerasPulsingImageId,
        },
      });

      this.map.addLayer({
        id: this.fixedPointCamerasLayerId,
        type: "symbol",
        minzoom: this.layersMinZoomOfFixedPointCameras,
        source: this.fixedPointCamerasSourceId,
        layout: {
          "icon-allow-overlap": true,
          "icon-pitch-alignment": "map",
          "icon-rotation-alignment": "map",
          "icon-image": "{icon}",
          "icon-rotate": {
            type: "identity",
            property: "direction",
          },
        },
        paint: {
          "text-color": "#FFFFFF",
          "text-halo-color": "#000000",
          "text-halo-width": 1,
        },
      });

      this.map.addLayer({
        id: this.fixedPointCamerasTextLayerId,
        type: "symbol",
        minzoom: this.layersMinZoomOfFixedPointCameras,
        source: this.fixedPointCamerasSourceId,
        layout: {
          // "text-allow-overlap": true,
          "text-field": "{name}",
          "text-size": 12,
          "text-offset": [
            "case",
            ["boolean", ["get", "isTextTop"], true],
            ["literal", [0, -2]],
            ["literal", [0, 2]],
          ],
        },
        paint: {
          "text-color": "#FFFFFF",
          "text-halo-color": "#000000",
          "text-halo-width": 1,
        },
      });
    },

    async onSelectCamera(cameraId) {
      this.closeUpCameraForcePlayFlg = true;
      this.setCloseUpCamera(cameraId);
      await this.jumpToCameraPosition(cameraId);
    },

    setCloseUpCamera(cameraId) {
      this.closeUpCamera = null;

      this.$nextTick(() => {
        if (cameraId && this.dispCameras.find((x) => x.id === cameraId)) {
          this.closeUpCamera = JSON.parse(
            JSON.stringify(this.dispCameras.find((x) => x.id === cameraId)),
          );
          FireStoreService.setAccountSetting("camera_list", {
            close_up_camera_id: cameraId,
          });
          this.mirroringVideo(true);
        }
      });
    },

    async jumpToCameraPosition(cameraId) {
      let centerLngLat = [];
      let zoom = 11;
      const vesselId = this.cameras.find(
        (camera) => camera.id === cameraId,
      ).vesselId;
      if (vesselId) {
        const lastPosition = await this.getLastPosition(vesselId);
        centerLngLat = [
          lastPosition ? lastPosition.longitude : null,
          lastPosition ? lastPosition.latitude : null,
        ];
      } else if (Object.keys(this.fixedPointCameraMap).includes(cameraId)) {
        const fixedPointCameraFeature = this.fixedPointCameraMap[cameraId];
        centerLngLat = fixedPointCameraFeature.geometry.coordinates;
      }

      if (centerLngLat.length === 2) {
        this.map.jumpTo({
          center: centerLngLat,
          zoom: zoom,
        });
      }
    },

    resetMapPosition() {
      this.map.flyTo({
        center: this.pos.center,
        zoom: this.pos.zoom,
        speed: 5,
      });
    },
    initMapPosition() {
      this.map.flyTo({
        center: this.pos.center,
        zoom: 4,
        speed: 5,
      });
    },
    async setupMapSources() {
      // mapSourceの初期化

      this.map.addSource(MapSource.VesselPointSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.VesselVectorSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.VesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.VesselWakeLineSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.VesselWakeLineSourceForClickEvent.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      /*=========================================================================================
         自社船 MapSource
        ==========================================================================================*/
      this.map.addSource(MapSource.OwnVesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.OwnVesselPointSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.OwnVesselMarkerSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      /*=========================================================================================
         選択船 MapSource
        ==========================================================================================*/
      this.map.addSource(MapSource.SelectedVesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.SelectedVesselPointSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.SelectedVesselMarkerSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      /*=========================================================================================
         アンカー船 MapSource
        ==========================================================================================*/
      this.map.addSource(MapSource.AnchorVesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.AnchorVesselPointSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.AnchorVesselMarkerSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });
    },

    vesselName(vessel) {
      return vessel.name_ja || vessel.name;
    },

    setGridSize(gridLayout, gridColNum) {
      this.gridLayout = gridLayout;
      this.gridColNum = gridColNum;

      this.gridWidth =
        gridLayout === 1 && gridColNum === 4
          ? "calc( ( 100% / 4 - 8px ) )"
          : gridLayout === 1 && gridColNum === 3
          ? "calc( ( 100% / 3 - 8px ) )"
          : gridLayout === 1 && gridColNum === 2
          ? "calc( ( 100% / 2 - 8px ) )"
          : gridLayout === 2 && gridColNum === 3
          ? "calc( ( 100% / 3 - 8px ) )"
          : gridLayout === 2 && gridColNum === 2
          ? "calc( ( 100% / 2 - 8px ) )"
          : gridLayout === 2 && gridColNum === 1
          ? "calc( ( 100% / 1 - 8px ) )"
          : gridLayout === 3 && gridColNum === 3
          ? "calc( ( 100% / 3 - 8px ) )"
          : gridLayout === 3 && gridColNum === 2
          ? "calc( ( 100% / 2 - 8px ) )"
          : "calc( ( 100% - 8px ) )";

      this.gridHeight =
        gridLayout === 1 && gridColNum === 4
          ? "calc( ( 100vh - 60px ) / 4 -  6px )"
          : gridLayout === 1 && gridColNum === 3
          ? "calc( ( 100vh - 60px ) / 3 -  6px )"
          : gridLayout === 1 && gridColNum === 2
          ? "calc( ( 100vh - 60px ) / 2 -  6px )"
          : gridLayout === 2 && gridColNum === 3
          ? "calc( ( 100vh - 60px ) / 4 -  6px )"
          : gridLayout === 2 && gridColNum === 2
          ? "calc( ( 100vh - 60px ) / 3 -  6px )"
          : gridLayout === 2 && gridColNum === 1
          ? "calc( ( 100vh - 60px ) / 2 -  6px )"
          : gridLayout === 3 && gridColNum === 3
          ? "calc( ( ( 100vh - (" +
            this.gridLayoutStyle("closeUpCameraBlock").height +
            ") ) / 2 - 38px ) )"
          : gridLayout === 3 && gridColNum === 2
          ? "calc( ( ( 100vh - (" +
            this.gridLayoutStyle("closeUpCameraBlock").height +
            ") ) / 2 - 38px ) )"
          : "calc( ( 100vh - 75px ) )";
    },

    mirroringVideo(mirroringVideoOn) {
      if (mirroringVideoOn) {
        this.$vs.loading({ container: "#close-up-camera-area" });
        setTimeout(() => {
          const ccId = `grid-view-live-camera-${this.closeUpCamera.id}`;
          var video = document.getElementById(ccId).querySelector("video");
          const videoRect = video.getBoundingClientRect();

          let closeUpCameraHeight = 250;
          if (this.$refs.closeUpCameraGrid) {
            closeUpCameraHeight =
              this.$refs.closeUpCameraGrid.$el.getBoundingClientRect().height -
              this.$refs.closeUpCameraGrid.cameraInfoBarHeight;
          }

          const scaleRateHeight = closeUpCameraHeight / videoRect.height;
          const scaleRateWidth = [4].includes(this.closeUpCamera.movieType)
            ? scaleRateHeight * (4 / 3 / (16 / 9))
            : [2, 5].includes(this.closeUpCamera.movieType)
            ? scaleRateHeight * (4 / 3 / (16 / 9))
            : scaleRateHeight * (4 / 3 / (16 / 9));

          var canvas = document.getElementById("close-up-canvas");
          canvas.getContext("2d").scale(scaleRateWidth, scaleRateHeight);
          canvas.width = videoRect.width * scaleRateWidth;
          canvas.height = videoRect.height * scaleRateHeight;

          const fps = 29.97; // DVDレベル
          const intervalId = setInterval(() => {
            canvas
              .getContext("2d")
              .drawImage(
                video,
                0,
                0,
                videoRect.width * scaleRateWidth,
                videoRect.height * scaleRateHeight,
              );
          }, 1000 / fps);
          this.intervalIdList.push(intervalId);

          this.$nextTick(() => {
            this.$vs.loading.close("#close-up-camera-area > .con-vs-loading");
          });
        }, 2000); // クローズアップカメラ領域の描画完了まで待つ canvasタグを捕まえるため。
      } else {
        this.intervalIdList.forEach((intervalId) => clearInterval(intervalId));
      }
    },

    backupFilterValue() {
      // リセット用に現在のフィルタ値をバックアップ
      this.origSwitchVesselAll = this.switchVesselAll;
      this.origSwitchOtherAll = this.switchOtherAll;
      this.origFilter = _.cloneDeep(this.filter);
    },

    updateFilterCondition() {
      // フィルタの決定ボタン
      this.filter.sortOrderName = this.sortOrderName;
      this.filterCamera(this.filter);
      this.isFilterSidebarActive = false;
    },

    async onResetFilter() {
      this.switchVesselAll = this.origSwitchVesselAll;
      this.switchOtherAll = this.origSwitchOtherAll;
      this.filter = _.cloneDeep(this.origFilter);
    },

    onClickCollapse() {
      document.getElementById("filter-sidebar-vessel-header").click();
      document.getElementById("filter-sidebar-other-header").click();
    },

    fetchSvgIcons() {
      ["iconGrid1", "iconGrid2", "iconGrid3"].forEach(async (itemIcon) => {
        const svgText = await fetch(this.iconGridPathMap[itemIcon]).then(
          (response) => {
            return response.text();
          },
        );
        const divElement = document.getElementById(`grid-button-${itemIcon}`);
        if (divElement) {
          divElement.innerHTML = svgText;
        }
      });
    },

    cleanup() {
      this.resetCameraListState();

      this.map = null;
      let mapElement = document.getElementById("map-on-camera-parent");
      if (mapElement) {
        //親要素内の子要素を削除
        mapElement.innerHTML = "";
      }
      this.destroyPolling();
    },
  },
  async created() {
    this.map = null;
    this.setGridSize(this.gridLayout, this.gridColNum);

    const webWorker = this.getAddonFlag("GKMG_AIS_FOR_SIGNAL")
      ? new WebWorkerForFetchVesselGeometryForSignal()
      : new WebWorkerForFetchVesselGeometry();
    webWorker.addEventListener("message", async (e) => {
      await this.setVesselGeometryToMapSources(e.data);
    });
    this.webWorker = webWorker;
  },
  async mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "0.8rem 0 0 0.8rem";
    let routerHeaderElement = document.getElementsByClassName("router-header");
    routerHeaderElement[0].style["margin-bottom"] = "0.2rem";

    this.fetchSvgIcons();

    this.allVesselIds = await this.fetchCameras();
    this.filter.vesselIds = this.allVesselIds;

    const prevRouteName =
      this.prevRoute && this.prevRoute.name ? this.prevRoute.name : "";
    FireStoreService.getAccountSetting("camera_list").then(
      (cameraListSettings) => {
        if (cameraListSettings) {
          if (prevRouteName.startsWith("enterprise-management-camera-")) {
            this.gridLayout =
              cameraListSettings["grid_layout"] || this.gridLayout;
            this.gridColNum =
              cameraListSettings["grid_col_num"] || this.gridColNum;
          } else {
            this.gridLayout = 3;
            this.gridColNum = 2;
            FireStoreService.setAccountSetting("camera_list", {
              grid_layout: this.gridLayout,
              grid_col_num: this.gridColNum,
            });
          }
          if (this.gridLayout === 3) {
            this.setCloseUpCamera(cameraListSettings["close_up_camera_id"]);
          }
        }
        this.setGridSize(this.gridLayout, this.gridColNum);
      },
    );

    const fixedPointCameraFeatures = await this.fetchFixedPointCameras();
    if (fixedPointCameraFeatures.features) {
      fixedPointCameraFeatures.features.map((camera) => {
        Vue.set(this.fixedPointCameraMap, camera.properties.cameraId, camera);
      });
    }

    this.loadMapbox();
  },
  beforeDestroy() {
    this.cleanup();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#enterprise-camera-list {
  .mapboxgl-canvas {
    border-radius: 8px;
    width: 100% !important;
  }

  .sort-button {
    margin: 0 1rem 0 0;
    width: 30px;
    border: 2px solid #48a0f4;
    height: 30px;
    border-radius: 4px;
    cursor: pointer;

    .sort-icon {
      color: #48a0f4;
    }
  }
  .filter-button {
    margin: 0px 1rem;
    width: 30px;
    border: 2px solid #48a0f4;
    height: 30px;
    border-radius: 4px;

    .filter-icon {
      color: #48a0f4;
    }
  }
  .filter-action-button {
    width: 46%;
    margin: 0.2rem;
    padding: 0.6rem;
    font-size: smaller;
  }
  .filter-sidebar-font-color {
    color: #c2c6ca;
  }
  .filter-sidebar-divide-color {
    background-color: #c2c6ca;
  }
  .filter-sidebar-background {
    background-color: #2d3240;
  }
  .filter-sidebar-list-by-category {
    background-color: #3f4655;
    padding: 0.6rem 1rem;
    border-radius: 0.4rem;
  }
  .grid-button {
    height: 2rem;
    margin: 0rem;
    border: 1px solid #48a0f4;
    cursor: pointer;
  }

  .grid-button-icon {
    height: 24px;
    min-width: 30px;
    svg {
      width: 16px;
      height: 16px;
    }
  }

  .grid-button-selected {
    background-color: #49a0f4;
    svg {
      path {
        stroke: $aisea-white;
      }
    }
    &:hover {
      background-color: #c9e3fc;
      svg {
        path {
          stroke: #49a0f4;
        }
      }
    }
  }
  .grid-button-unselected {
    &:hover {
      background-color: #c9e3fc;
    }
  }
  #close-up-camera-area {
    margin: 0 0 8px 8px;
    background-color: silver;
    border-radius: 8px;
  }

  .vs-collapse {
    padding: 0;
  }

  .vs-collapse-item--header {
    padding: 0;
  }

  .vs-collapse-item--icon-header {
    right: -15px;

    .vs-icon {
      font-size: 2rem;
      color: $aisea-white;
    }
  }

  .con-content--item {
    padding: 0;
  }
}
.camera-list-layout-dropdown {
  padding-top: 10px;
  z-index: 99999;
  a {
    padding: 0;
  }
  .camera-list-layout-dropdown-item {
    height: 1.4rem;
    padding: 1rem 1rem;
    margin: 0;
    border-radius: 0.4rem;
    &:hover {
      background-color: #56ccf240;
    }
  }
  .vs-dropdown--item {
    margin: 0;
    min-width: fit-content;
  }
  .vs-dropdown--menu--after {
    background-color: rgba(255, 255, 255, 0);
    border: none;
  }
}
</style>
